import React, { useState } from 'react'
import { Descriptions } from 'antd'
import { Badge, Button } from 'reactstrap'
import moment from 'moment'
import EditSstPostModal from './EditSstPostModal'

const { Item } = Descriptions

export default function SstPostDetailsWidget({ sstPost, reload }) {
	const [showEditModal, setShowEditModal] = useState(false)

	return (
		<React.Fragment>
			<Descriptions size="small" column={1}>
				<Item>
					{sstPost.is_published ? <Badge color='success'>Publicado</Badge> : <Badge color='warning'>Borrador</Badge>}
				</Item>
				<Item label="Título">{sstPost.name}</Item>
				<Item label="Resumen">{sstPost.excerpt}</Item>
				<Item label="ID Publicación">#00{sstPost.id}</Item>
				<Item label="Fecha Creación">{moment(sstPost.created_at).format('YYYY-MM-DD HH:mm')}</Item>
				<Item label="Fecha Última Modificación">{moment(sstPost.updated_at).format('YYYY-MM-DD HH:mm')}</Item>
			</Descriptions>
			<div className='mt-2'>
				<Button color="primary" outline onClick={() => setShowEditModal(true)}>
					Actualizar Datos
				</Button>
			</div>
			{ showEditModal && (
				<EditSstPostModal
					visible
					onClose={() => setShowEditModal(false)}
					sstPost={sstPost}
					reload={() => {
						setShowEditModal(false)
						reload()
					}}
				/>
			)}
		</React.Fragment>
	)
}